import axios from 'axios'
import store from '@/store'
import router from '../router'
import Vue from 'vue'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000, // request timeout
  withCredentials: true
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (config.customHeaders) {
      config.headers = { ...config.headers, ...config.customHeaders }
    }
    if (!(config.customHeaders && config.customHeaders.noLoading)) {
      window.bus.$vux.loading.show({
        text: '正在加载...'
      })
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    window.bus.$vux.loading.hide()
    // if the custom code is not 20000, it is judged as an error.
    if (res.status === -1) {
      Vue.prototype.$common.toastMsg(res.message, 'warn')
      Vue.ls.remove('WxUserOpenIDNew')
      router.push({
        path: '/searchIndex'
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Vue.prototype.$common.toastMsg(error.message, 'warn')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js